<div *ngIf="bonusAvailable" class="dashboard-wrap">
  <div class="container-fluid">
      <div class="dashboard-bonus">
        <div class="top-section">
          <div class="top-section-left">
            <div class="top-section-icon"></div>
            <div class="top-section-title">{{'dashboardBonusData.accumulativeBonus' | translate}}</div>
          </div>
          <div class="top-section-right">
            <div class="top-section-button site-btn site-btn--lg">
              <span class="view-text">{{'dashboardBonusData.viewProgress' | translate}}</span>
              <span class="close-text">{{'dashboardBonusData.close' | translate}}</span>
            </div>
          </div>
        </div>

        <div class="bottom-section">
          <div class="bottom-section-panel" *ngFor="let bonusData of bonusDetails">
              <div class="bonus-info">
                <div class="bonus-info-left">
                  <div class="bonus-progress">
                    <div class="bonus-info-title">{{'dashboardBonusData.wageringProgress' | translate}}</div>
                    <span class="bonus-info-data">
                      {{mathObj.round(bonusData.wageredPercent * 100) / 100}}%<span class="bonus-utilized-value">{{userCurrencySymbol}}{{bonusData.currentWagerAmount}} of {{userCurrencySymbol}}{{bonusData.totalWagerAmount}}</span>
                    </span>
                  </div>
                  <div class="bonus-name">
                    <div class="bonus-info-title">{{'dashboardBonusData.bonusName' | translate}}</div>
                    <span class="bonus-info-data">{{bonusData.bonusName}}</span>
                  </div>
                  <div class="bonus-amount">
                    <div class="bonus-info-title">{{'dashboardBonusData.bonusAmount' | translate}}</div>
                    <span class="bonus-info-data">{{userCurrencySymbol}}{{(bonusData.offeredCRP + bonusData.offeredDRP + bonusData.offeredRRP)}}</span>
                  </div>
                </div>
                <div class="bonus-info-right">
                  <div class="bonus-desciption" *ngIf="bonusData.distanceToRelease != 0">{{'dashboardBonusData.bonusWillCredit' | translate}}</div>
                  <div class="bonus-desciption" *ngIf="bonusData.distanceToRelease == 0">{{'dashboardBonusData.bonusWasCredited' | translate}}</div>
                </div>    
              </div>
              <div class="bonus-progressbar-outer">
                <div class="bonus-progressbar-inner" [ngStyle]="{'width': bonusData.wageredPercent+'%'}"></div>
              </div>
          </div>   
        </div>
      </div>
  </div>
</div>
  
  